module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bsMwA"))).then(() => parcelRequire('37nVf'));